import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { LocalizePointsTransactionPipe } from './localize-points-transaction.pipe';

@NgModule({
  declarations: [LocalizePointsTransactionPipe],
  imports: [CommonModule],
  exports: [LocalizePointsTransactionPipe],
})
export class LocalizePointsTransactionPipeModule {}
